module.exports = __webpack_public_path__ + "static/call_lightning-11b16fd416d3b0441127cfdbad2e2335.webp";